<template>
  <div id="appSceneBox" class="app-scene-wrap">
    <div class="kad-container">
      <div class="kad-card-la-title card">
        <i class="svg"><img src="../../assets/home/codeicon2.svg" alt=""></i>
        公司介绍
      </div>
      <div class="kax-box">
        <div class="kax-box-content">
          <div class="kax-box-content-text">
            <p>
              <span class="stress-cell">深圳市带塔云科技有限公司</span
              >是一家专注于为企业数据分析服务的科技公司，公司成立于2021年5月25日。 
            </p>
            <p class="cetexs">
              <span class="stress-cell"></span
              >2021年6月，公司获得美国Betrue大中华区域独家代理权，并允许在大中华区域开展技术再创新，以及针对大中华市场的企业提供服务。
            </p>
            <p>
              <span class="stress-cell"></span
              >为更好推广，经Betrue全球总裁Josiah的授权，在大中华区域品牌名称将改成快现形。 
            </p>
          </div>
          <div class="iocn">
            <img src="../../assets/icons/kxxlogo.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="kad-container">
      <div class="kad-card-la-title"><i class="svges">
        <img src="../../assets/home/codeiocn1.svg" alt="">
        </i>产品介绍</div>
      <div class="card-titles">
        <span></span>快现形是一个跨境账号征信平台，协助企业解决运营中遇到的问题，立志于为企业跨境出海保驾护航！
      </div>
      <div class="unused">
        <div class="item" v-for="item in list" :key="item.id">
          <div class="title">{{ item.title }}</div>
          <div class="txt">
            {{ item.txt }}
          </div>
          <div class="footer-img"></div>
        </div>
      </div>
      <div class="client-box">
        <div class="kad-card-la-title"><i class="svg">
           <img src="../../assets/home/codeiocn3.svg" alt=""></i>客户评价</div>
        <div class="client-img-box">
          <img src="../../assets/home/clientBg.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      list: [
        {
          id: 1,
          title: "第一时间甄别买家账号安全",
          txt: "商家在做推广、产品试用时，只要输入买家的profile相关信息，就可以第一时间查出买家账号36个维度的分析指标，从而迅速确认账号是否安全，快速筛选出问题买家、恶意买家、黑名单账号等。",
        },
        {
          id: 2,
          title: "曝光骗子账号",
          txt: "可以第一时间查看和曝光买家骗子账号，包括买家骗子、Facebook骗子、职业差评师等，从而让自己尽量避免上当，让其它卖家避免上当，打造一个健康的营商环境。",
        },
        {
          id: 3,
          title: "曝光中介服务商骗子",
          // txt: '技术与分享核心团队来自美国西雅图，有7年以上亚马逊买家数据分析经验；能够实时分析亚马逊买家账号的各种风险。'
          txt: "可以在平台上曝光无良的中介服务商，让他们无所遁形，包括曝光骗子微信号等。总体而言，Betrue/快现形可以帮助卖家迅速查询出问题账号，提前发现问题，从而能够在第一时间减少运营损失。",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.kad-container {
  width: 1200px;
  .card {
    margin-bottom: 30px;
  }
}
.kad-card-la-title {
  font-size: 28px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #24232f;
  .svg {
    display: inline-block;
    margin-right: 10px;
    vertical-align:middle;
  }
  .svges {
    vertical-align:middle;
    margin-right: 10px;
    display: inline-block;
    // background: url("../../assets/home/codeiocn1.svg") no-repeat;
  }
}
.client-box {
  // display: flex;
  // justify-content: center;
  padding-top: 20px;
  // background: url('../../assets/use-course/course-bg.png') no-repeat;
  background-size: 100% 528px;
  .kad-card-la-title{
    margin-bottom: 25px;
    .svg{
      vertical-align:middle;
    }
  }
  .client-img-box {
    width: 1200px;
    margin: 0 auto;
    img {
      width: 104%;
      margin-left: -24px;
    }
  }
  /*
    img {
      width: 1200px;
    }
    */
}
.kax-box {
  margin-bottom: 40px;
}
.kax-box-content-text {
  width: 66%;
  display: inline-block;
  //   font-size: 20px;
  font-family: Microsoft YaHei;
  color: #373e4f;
  line-height: 30px;
  margin-right: 85px;
  .cetexs {
    margin: 10px 0;
  }
  .stress-cell {
    font-size: 20px;
  }
  p {
    font-size: 16px;
  }
}
.iocn {
  width: 25%;
  display: inline-block;
  img {
    width: 210px;
    height: 60px;
    margin-bottom: 50px;
  }
}
.card-titles {
  font-size: 16px;
  color: #373e4f;
  line-height: 30px;
  margin-bottom: 30px;
  margin-top: 10px;
  span {
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
  }
}
.unused {
  display: flex;
  width: 100%;
  margin-bottom: 30px;
  .item {
    position: relative;
    flex: 1;
    height: 363px;
    background: #fefefe;
    padding: 35px 30px 0;
    width: 380px;
    height: 380px;
    box-shadow: 0px 2px 12px 0px rgba(216, 221, 235, 0.6);
    border-radius: 4px;
    .title {
      font-size: 20px;
      font-weight: bold;
      color: #24232f;
      margin-bottom: 24px;
      text-align: center;
    }
    .txt {
      font-size: 16px;
      font-weight: 400;
      color: #767d8f;
      line-height: 30px;
    }
    .footer-img {
      position: absolute;
      bottom: 25px;
      right: 20px;
    }
  }
  .item:nth-child(1) {
    // background: url('../../../assets/home/client1.png');
    background-size: 100% 100%;
    margin-right: 15px;
    .footer-img {
      width: 214px;
      height: 101px;
      background: url("../../assets/home/tration1.png");
      background-size: 100% 100%;
    }
  }
  .item:nth-child(2) {
    margin: 0 15px;
    // background: url('../../../assets/home/client2.png');
    background-size: 100% 100%;
    .footer-img {
      width: 214px;
      height: 101px;
      background: url("../../assets/home/tration2.png");
      background-size: 100% 100%;
    }
  }
  .item:nth-child(3) {
    margin-left: 15px;
    // background: url('../../../assets/home/client3.png');
    background-size: 100% 100%;
    .footer-img {
      width: 214px;
      height: 101px;
      background: url("../../assets/home/tration3.png");
      background-size: 100% 100%;
    }
  }
}
</style>
